import { useState, useRef } from 'react';
import type { PropsWithChildren } from 'react';
import { CollapseAndFade } from '@buoyhealth/common.buoy-layout';
import { TextButton } from '@buoyhealth/common.buoy-button';
import useIsPolaris from '../hooks/useIsPolaris';

interface ICollapsibleResultsProps extends PropsWithChildren<any> {
  isShowingResults: boolean;
}

/** Displays children in a collapsible view that has a fade-out gradient */
const CollapsibleResults = ({ children, isShowingResults }: ICollapsibleResultsProps) => {
  const isPolaris = useIsPolaris();

  const scrollTopRef = useRef<HTMLDivElement>(null);

  const [collapseResults, setCollapseResults] = useState(!isPolaris);

  const toggleCollapsedResults = () => {
    const isCollapsed = !collapseResults;
    setCollapseResults(isCollapsed);
    if (isCollapsed) {
      scrollTopRef.current?.scrollIntoView();
    }
  };

  if (isPolaris) {
    return children;
  }

  return (
    <>
      <div ref={scrollTopRef} />
      <CollapseAndFade
        show={!collapseResults && isShowingResults}
        collapsedSize={!isPolaris && isShowingResults ? '155px' : undefined}
        gradientFadeOutColor={'255, 255, 255'}
      >
        {children}
      </CollapseAndFade>
      {!isPolaris && isShowingResults && (
        <TextButton
          sx={{
            textDecoration: 'underline',
            fontSize: '16px !important',
            marginTop: '16px',
          }}
          onClick={toggleCollapsedResults}
        >
          {collapseResults ? 'Expand' : 'Collapse'} results
        </TextButton>
      )}
    </>
  );
};

export default CollapsibleResults;
